import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.00359 0C8.45359 0 8.00359 0.45 8.00359 1V9C8.00359 9.55 8.45359 10 9.00359 10C9.55359 10 10.0036 9.55 10.0036 9V1C10.0036 0.45 9.55359 0 9.00359 0ZM14.1436 2.86C13.7536 3.25 13.7636 3.86 14.1336 4.25C15.2636 5.45 15.9636 7.05 16.0036 8.82C16.0936 12.65 12.9236 15.95 9.09359 15.99C5.18359 16.05 2.00359 12.9 2.00359 9C2.00359 7.16 2.71359 5.49 3.87359 4.24C4.24359 3.85 4.24359 3.24 3.86359 2.86C3.46359 2.46 2.81359 2.47 2.43359 2.88C0.983593 4.42 0.0735926 6.47 0.00359261 8.74C-0.136407 13.62 3.83359 17.84 8.71359 17.99C13.8136 18.15 18.0036 14.06 18.0036 8.99C18.0036 6.62 17.0836 4.48 15.5836 2.88C15.2036 2.47 14.5436 2.46 14.1436 2.86Z" })
});
export default SvgLogout;
